module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sa-refund-dash"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("财务管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("班主任退费看板")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dash-head"
  }, [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("班主任退费看板")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v(_vm._s(_vm.periodNote || '统计口径加载中…'))])])]), _vm._v(" "), _c('div', {
    staticClass: "filterbar"
  }, [_c('span', {
    staticClass: "fblabel"
  }, [_vm._v("时间范围")]), _vm._v(" "), _c('div', {
    staticClass: "seg"
  }, [_c('button', {
    class: {
      on: _vm.mode === 'days' && _vm.days === 30
    },
    on: {
      "click": function($event) {
        return _vm.setDays(30)
      }
    }
  }, [_vm._v("近30天")]), _vm._v(" "), _c('button', {
    class: {
      on: _vm.mode === 'days' && _vm.days === 90
    },
    on: {
      "click": function($event) {
        return _vm.setDays(90)
      }
    }
  }, [_vm._v("近90天")]), _vm._v(" "), _c('button', {
    class: {
      on: _vm.mode === 'days' && _vm.days === 180
    },
    on: {
      "click": function($event) {
        return _vm.setDays(180)
      }
    }
  }, [_vm._v("近180天")]), _vm._v(" "), _c('button', {
    class: {
      on: _vm.mode === 'all'
    },
    on: {
      "click": _vm.setAll
    }
  }, [_vm._v("全部")])]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "按月份查看…"
    },
    on: {
      "on-change": _vm.onMonth
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  }, _vm._l((_vm.monthOptions), function(m) {
    return _c('Option', {
      key: m,
      attrs: {
        "value": m
      }
    }, [_vm._v(_vm._s(m))])
  }), 1), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "date",
      "placeholder": "开始"
    },
    on: {
      "on-change": _vm.onCustomDate
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "muted"
  }, [_vm._v("至")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "date",
      "placeholder": "结束"
    },
    on: {
      "on-change": _vm.onCustomDate
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "clear-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetRange.apply(null, arguments)
      }
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "全部班主任",
      "disabled": !_vm.privileged && _vm.advisers.length <= 1
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.studyAdviserId),
      callback: function($$v) {
        _vm.studyAdviserId = $$v
      },
      expression: "studyAdviserId"
    }
  }, _vm._l((_vm.advisers), function(a) {
    return _c('Option', {
      key: a.id,
      attrs: {
        "value": a.id
      }
    }, [_vm._v(_vm._s(a.name))])
  }), 1), _vm._v(" "), (_vm.periodLabel) ? _c('span', {
    staticClass: "range-text"
  }, [_vm._v("当前："), _c('b', [_vm._v(_vm._s(_vm.periodLabel))]), _vm._v("（" + _vm._s(_vm.periodDays) + " 天）")]) : _vm._e(), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.load
    }
  }, [_vm._v("刷新")])], 1), _vm._v(" "), (_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kpis"
  }, _vm._l((_vm.kpiCards), function(c) {
    return _c('div', {
      key: c.lab,
      staticClass: "kpi",
      class: c.cls
    }, [_c('div', {
      staticClass: "lab"
    }, [_vm._v(_vm._s(c.lab))]), _vm._v(" "), _c('div', {
      staticClass: "val"
    }, [_vm._v(_vm._s(c.val)), (c.unit) ? _c('small', [_vm._v(_vm._s(c.unit))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "foot"
    }, [_vm._v(_vm._s(c.foot))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("预警提示 "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.alerts.length))])]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("规则自动触发，优先级从高到低")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-bd"
  }, [(!_vm.alerts.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("当前周期内没有触发预警，团队状态平稳。")]) : _c('div', {
    staticClass: "alerts"
  }, _vm._l((_vm.alerts), function(a, i) {
    return _c('div', {
      key: i,
      staticClass: "alert",
      class: a.level
    }, [_c('div', [_c('div', {
      staticClass: "who"
    }, [_vm._v(_vm._s(a.teacher) + "\n              "), _c('span', {
      staticClass: "badge",
      class: _vm.levelBadge(a.level)
    }, [_vm._v(_vm._s(_vm.levelLabel(a.level)))])]), _vm._v(" "), _c('div', {
      staticClass: "txt",
      domProps: {
        "innerHTML": _vm._s(a.text)
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "grid2"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-bd"
  }, [(!_vm.rateRows.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rateRows), function(r) {
    return _c('div', {
      key: 'r' + r.studyAdviserId,
      staticClass: "bar-row"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": r.teacher
      }
    }, [_vm._v(_vm._s(r.teacher))]), _vm._v(" "), _c('div', {
      staticClass: "track"
    }, [_c('div', {
      staticClass: "fill",
      style: ({
        width: _vm.rateWidth(r.rate) + '%',
        background: r.riskColor || '#3b82f6'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "avgline",
      style: ({
        left: _vm.avgRateLeft + '%'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "num"
    }, [_c('b', [_vm._v(_vm._s(_vm.pct(r.rate)))]), _vm._v(" "), _c('span', {
      staticClass: "muted"
    }, [_vm._v(_vm._s(r.refundCount) + "人")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "avglegend"
  }, [_vm._v("虚线为团队均值 "), _c('b', [_vm._v(_vm._s(_vm.pct(_vm.avgRate)))]), _vm._v(" · 分级按 90 天口径折算")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-bd"
  }, [(!_vm.reasonRows.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无退费记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.reasonRows), function(r, i) {
    return _c('div', {
      key: 'c' + r.category,
      staticClass: "bar-row reason"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": r.name
      }
    }, [_vm._v(_vm._s(r.name))]), _vm._v(" "), _c('div', {
      staticClass: "track"
    }, [_c('div', {
      staticClass: "fill",
      style: ({
        width: _vm.reasonWidth(r.count) + '%',
        background: _vm.palette[i % _vm.palette.length]
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "num"
    }, [_c('b', [_vm._v(_vm._s(r.count))]), _vm._v(" "), _c('span', {
      staticClass: "muted"
    }, [_vm._v(_vm._s(_vm.pct(r.share)))])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-bd"
  }, [_c('div', {
    staticClass: "cols"
  }, _vm._l((_vm.trend), function(t) {
    return _c('div', {
      key: t.month,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "cval"
    }, [_vm._v(_vm._s(t.count || ''))]), _vm._v(" "), _c('div', {
      staticClass: "cbar",
      style: ({
        height: _vm.trendHeight(t.count) + 'px'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "clab"
    }, [_vm._v(_vm._s(t.month.slice(5)) + "月")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-bd scroll"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.teacherColumns,
      "data": _vm.teacherRows,
      "size": "small",
      "loading": _vm.loading
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("退费学生明细")]), _vm._v(" "), _c('div', {
    staticClass: "filterbar inline"
  }, [_c('Input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "搜学生姓名/班主任",
      "clearable": ""
    },
    on: {
      "on-enter": _vm.load,
      "on-clear": _vm.load
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "全部原因"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.reasonCategory),
      callback: function($$v) {
        _vm.reasonCategory = $$v
      },
      expression: "reasonCategory"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("外教原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("学导原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("销售原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("技术原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("产品原因")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("学生客观原因")])], 1), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "新生+续费"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.signType),
      callback: function($$v) {
        _vm.signType = $$v
      },
      expression: "signType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "新生"
    }
  }, [_vm._v("仅新生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "续费"
    }
  }, [_vm._v("仅续费")])], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.load
    }
  }, [_vm._v("筛选")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-bd scroll"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.studentColumns,
      "data": _vm.studentRows,
      "size": "small",
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading && !_vm.studentRows.length) ? _c('div', {
    staticClass: "empty",
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v("没有符合条件的退费记录")]) : _vm._e()], 1), _vm._v(" "), _vm._m(4)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("各班主任退费率")]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("退费率 = 退费人数 ÷ 在册")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("退费原因分布")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("近 6 个月退费趋势")]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("按申请时间 · 人数去重")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-hd"
  }, [_c('h2', [_vm._v("班主任明细")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot-note"
  }, [_c('b', [_vm._v("口径说明：")]), _vm._v("退费率 = 周期内退费人数 ÷ 周期内在册学员（曾归属 − 期前退费完结）；金额优先实际退款金额；\n      退费状态含已审核/已退费/劝退成功；时间按申请时间；新生/续费按购买渠道。三数（新生、续费、退费）不可直接相除。\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34f52142","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/financial/StudyAdviserRefundDashboard.vue
// module id = 1746
// module chunks = 8